<template>
    <div>
        <app-text
            label="YouTube oder Vimeo-Link/ID"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.source'"
            required
            :maxlength="255"
            pattern="^[a-zA-Z0-9_\-]+$|^https?:\/\/(www.)?youtube.+$|^https?:\/\/(www.)?vimeo.+$"
        ></app-text>

        <app-wysiwyg
            label="Video Titel"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.title'"
            :maxlength="75"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Video Untertitel"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.subtitle'"
            :maxlength="75"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Video Text"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.text'"
            :maxlength="350"
        ></app-wysiwyg>

        <app-checkbox
            label="Loop"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.loop'"
        ></app-checkbox>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Checkbox from '@/components/fields/simple/Checkbox.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R086'),
            help: this.$helpers.uiText('R087'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg,
        'app-checkbox': Checkbox
    }
};
</script>
